export class ExecutiveSummaryTransactionModel {
  public ExecutiveSummaryTransactionModel() {}
  public periodList!: Array<ExecutiveSummaryPeriodModel>;
  public periodType!: number;
  public fromDate!: string;
  public toDate!: string;
  public operationIncome!: ExecutiveSummaryTransactionItemModel;
  public costsOfSales!: ExecutiveSummaryTransactionItemModel;
  public grossProfit!: ExecutiveSummaryTransactionItemModel;
  public expenses!: ExecutiveSummaryTransactionItemModel;
  public costOfFinancing!: ExecutiveSummaryTransactionItemModel;
  public taxRevenues!: ExecutiveSummaryTransactionItemModel;
  public netProfit!: ExecutiveSummaryTransactionItemModel;
  public cashReceived!: ExecutiveSummaryTransactionItemModel;
  public cashSpent!: ExecutiveSummaryTransactionItemModel;
  public gainsInForeignExchange!: ExecutiveSummaryTransactionItemModel;
  public netCashReceived!: ExecutiveSummaryTransactionItemModel;
  public cashBalance!: ExecutiveSummaryTransactionItemModel;
  public accountsReceivable!: ExecutiveSummaryTransactionItemModel;
  public inventory!: ExecutiveSummaryTransactionItemModel;
  public accountsPayable!: ExecutiveSummaryTransactionItemModel;
  public quickRatio!: ExecutiveSummaryTransactionItemModel;
  public inventoryTurnOver!: ExecutiveSummaryTransactionItemModel;
  public receivablesTurnOver!: ExecutiveSummaryTransactionItemModel;
  public accountPayableTurnOverRatio!: ExecutiveSummaryTransactionItemModel;
  public averagePaymentPeriod!: ExecutiveSummaryTransactionItemModel;
  public averageInventoryPeriod!: ExecutiveSummaryTransactionItemModel;
  public averageCollectionPeriod!: ExecutiveSummaryTransactionItemModel;
  public cashConversionCycle!: ExecutiveSummaryTransactionItemModel;
  public quotationNumberIssued!: ExecutiveSummaryTransactionItemModel;
  public quotationNetAmountIssued!: ExecutiveSummaryTransactionItemModel;
  public quotationAverageIssued!: ExecutiveSummaryTransactionItemModel;
  public invoiceNumberIssued!: ExecutiveSummaryTransactionItemModel;
  public invoiceNetAmountIssued!: ExecutiveSummaryTransactionItemModel;
  public invoiceAverageIssued!: ExecutiveSummaryTransactionItemModel;
  public roe!: ExecutiveSummaryTransactionItemModel;
  public netProfitMargin!: ExecutiveSummaryTransactionItemModel;
  public totalAssetTurnOver!: ExecutiveSummaryTransactionItemModel;
  public equityMultiplier!: ExecutiveSummaryTransactionItemModel;
  public roa!: ExecutiveSummaryTransactionItemModel;
  public totalEquityTurnOver!: ExecutiveSummaryTransactionItemModel;
  public grossProfitRatio!: ExecutiveSummaryTransactionItemModel;
}
export class ExecutiveSummaryTransactionItemModel {
  public type!: number;
  public remark: ExecutiveSummaryRemarkModel = new ExecutiveSummaryRemarkModel();
  public accountList!: Array<ExecutiveSummaryAccountModel>;
  public summaryList!: Array<ExecutiveSummaryValueModel>;
}
export class ExecutiveSummaryAccountModel {
  public accountId!: number;
  public accountName!: string;
  public accountNameTh!: string;
  public accountNameEn!: string;
  public accountCode!: string;
  public valueList!: Array<ExecutiveSummaryValueModel>;
}
export class ExecutiveSummaryValueModel {
  public value!: number;
  public beforeValue!: number;
  public changePercent!: number;
}
export class ExecutiveSummaryPeriodModel {
  public fromDate!: Date;
  public toDate!: Date;
  public fromChangeDate!: Date;
  public toChangeDate!: Date;
}
export class ExecutiveSummaryRemarkModel {
  public isHaveRemark: boolean = false;
  public no: number = 0;
  public header: string = "";
  public description: string = "";
  public isShowDescription: boolean = true;
}
export class ExecutiveSummarySelectedDateModel {
  public executiveSummaryPeriodType: number = 1;
  public fromDate: string = new Date().ToDateJsonString();
  public toDate: string = new Date().ToDateJsonString();
}
export class ExecutiveSummarySettingModel {
  public operationIncomeHidden: boolean = false;
  public costsOfSalesHidden: boolean = false;
  public grossProfitHidden: boolean = true;
  public expensesHidden: boolean = false;
  public costOfFinancingHidden: boolean = true;
  public taxRevenuesHidden: boolean = true;
  public netProfitHidden: boolean = false;
  public cashReceivedHidden: boolean = false;
  public cashSpentHidden: boolean = false;
  public gainsInForeignExchangeHidden: boolean = true;
  public netCashReceivedHidden: boolean = false;
  public cashBalanceHidden: boolean = false;
  public accountsReceivableHidden: boolean = false;
  public inventoryHidden: boolean = false;
  public accountsPayableHidden: boolean = false;
  public quickRatioHidden: boolean = true;
  public inventoryTurnOverHidden: boolean = true;
  public receivablesTurnOverHidden: boolean = true;
  public accountPayableTurnOverRatioHidden: boolean = true;
  public averagePaymentPeriodHidden: boolean = false;
  public averageInventoryPeriodHidden: boolean = false;
  public averageCollectionPeriodHidden: boolean = false;
  public cashConversionCycleHidden: boolean = false;
  public quotationNumberIssuedHidden: boolean = false;
  public quotationNetAmountIssuedHidden: boolean = false;
  public quotationAverageIssuedHidden: boolean = true;
  public invoiceNumberIssuedHidden: boolean = false;
  public invoiceNetAmountIssuedHidden: boolean = false;
  public invoiceAverageIssuedHidden: boolean = true;
  public grossProfitRatioHidden: boolean = false;
  public netProfitMarginHidden: boolean = false;
  public roeHidden: boolean = false;
  public roaHidden: boolean = false;
  public equityMultiplierHidden: boolean = false;
  public totalAssetTurnOverHidden: boolean = true;
  public totalEquityTurnOverHidden: boolean = true;
}

export class ExecutiveSummaryDetailModel {
  public id!: number;
  public uuId!: string;
  public status!: number;
  public isDeleted!: boolean;
  public number!: string;
  public name!: string;
  public fromDate!: Date;
  public toDate!: Date;
  public createdUserId!: number;
  public createdDateTime!: Date;
  public approvedUserId!: number;
  public approvedDateTime!: Date;
  public updatedUserId!: number;
  public updatedDateTime!: Date;
  public setting!: ExecutiveSummarySettingModel;
  public transaction!: ExecutiveSummaryTransactionModel;
}

export class ReportSearchCriteria {
  public fromDate!: Date;
  public toDate!: Date;
  executiveSummaryPeriodType!: number;
  executiveSummaryId!: number;
}
export class ExecutiveSummarySettingInPageModel {
  public operationIncomeShow: boolean = true;
  public costsOfSalesShow: boolean = true;
  public grossProfitShow: boolean = true;
  public expensesShow: boolean = true;
  public costOfFinancingShow: boolean = true;
  public taxRevenuesShow: boolean = true;
  public netProfitShow: boolean = true;
  public cashReceivedShow: boolean = true;
  public cashSpentShow: boolean = true;
  public gainsInForeignExchangeShow: boolean = true;
  public netCashReceivedShow: boolean = true;
  public cashBalanceShow: boolean = true;
  public accountsReceivableShow: boolean = true;
  public inventoryShow: boolean = true;
  public accountsPayableShow: boolean = true;
  public quickRatioShow: boolean = true;
  public inventoryTurnOverShow: boolean = true;
  public receivablesTurnOverShow: boolean = true;
  public accountPayableTurnOverRatioShow: boolean = true;
  public averagePaymentPeriodShow: boolean = true;
  public averageInventoryPeriodShow: boolean = true;
  public averageCollectionPeriodShow: boolean = true;
  public cashConversionCycleShow: boolean = true;
  public quotationNumberIssuedShow: boolean = true;
  public quotationNetAmountIssuedShow: boolean = true;
  public quotationAverageIssuedShow: boolean = true;
  public invoiceNumberIssuedShow: boolean = true;
  public invoiceNetAmountIssuedShow: boolean = true;
  public invoiceAverageIssuedShow: boolean = true;
  public grossProfitRatioShow: boolean = true;
  public netProfitMarginShow: boolean = true;
  public roeShow: boolean = true;
  public roaShow: boolean = true;
  public equityMultiplierShow: boolean = true;
  public totalAssetTurnOverShow: boolean = true;
  public totalEquityTurnOverShow: boolean = true;
}
